import angular from 'angular';
import {
	Keymaps,
	LanguageExtensions,
	Plugins,
	ThemeExtensions,
} from '@knitiv/code-editor';

// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevDroitController {
	/* @ngInject */
	/**
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('~/scripts/services/model/node-service').NodeService} NodeService
	 */
	constructor($timeout, NodeService) {
		this.$timeout = $timeout;
		this.NodeService = NodeService;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.kid = undefined;

		this.node = undefined;

		this.readOnly = true;
		this.tmpDroits = '';
		this.loadNode();
	}

	loadNode() {
		this.$timeout(async () => {
			if (this.kid) {
				const node = await this.NodeService.load(this.kid);
				this.node = node || undefined;
			}
			else {
				this.node = undefined;
			}
			this.updateData();
		});
	}

	onEditorSetup() {
		return [
			ThemeExtensions.oneLight,
			LanguageExtensions.json(),

			Plugins.FOLD_GUTTERS(),
			Plugins.MATCH_BRACKETS(),
			Plugins.AUTOCOMPLETION(),
			Plugins.CLOSE_BRACKETS(),
			Plugins.DRAW_SELECTION(),
			Plugins.DROP_CURSOR(),
			Plugins.HIGHLIGHT_ACTIVE_LINE_GUTTER(),
			Plugins.HIGHLIGHT_SELECTION_MATCHES(),
			Plugins.HIGHLIGHT_SPECIAL_CHARS(),
			Plugins.HISTORY(),
			Plugins.INDENT_ON_INPUT(),
			Plugins.MULTIPLE_CURSORS(),
			Plugins.RECTANGULAR_SELECTION(),
			Plugins.LINE_NUMBERS(),
			Plugins.KEYMAP.of(Keymaps.KNITIV_KEYMAP),
		];
	}

	updateData() {
		this.$timeout(() => {
			this.tmpDroits = angular.toJson({
				droit:     this.node?.droit ?? [],
				droitcust: this.node?.droitcust ?? [],
				droitdef:  this.node?.droitdef ?? [],
			}, true);
		});
	}
}
